import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGE_CODES,
  normalizeToSupportedLanguage,
} from "./config";
import resources from "./resources";

const languageDetector = new LanguageDetector();

languageDetector.addDetector({
  name: "qubiqNavigator",
  lookup() {
    if (typeof window === "undefined") return undefined;

    const candidates = Array.isArray(window.navigator?.languages)
      ? window.navigator.languages
      : [window.navigator?.language];

    return candidates.find(Boolean);
  },
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    ns: ["common", "legal"],
    defaultNS: "common",
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "qubiqNavigator", "htmlTag"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
      convertDetectedLanguage: (language) =>
        normalizeToSupportedLanguage(language),
    },
  });

const syncDocumentLanguage = (language) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = normalizeToSupportedLanguage(language);
};

syncDocumentLanguage(i18n.resolvedLanguage || i18n.language);
i18n.on("languageChanged", syncDocumentLanguage);

export default i18n;
